import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { Grid, GridItem } from '../../../../../ui';
import { INewsStory } from '../../../../shared/api/contentful/types/INewsStory';
import NewsCard from '../NewsCard';
import { removePaginationFromPath } from '../../../helpers/removePaginationFromPath';
import NewsCardNoImage from '../../../../../../assets/icons/no-image.svg?reference';
import { NoSearchResultsMessage } from '../NoSearchResultsMessage';

interface IHighlighedNewsStoryProps {
	newsStories: INewsStory[];
}

export const NewsStoriesList = ({ newsStories }: IHighlighedNewsStoryProps) => {
	const router = useRouter();
	const asPath = removePaginationFromPath(router.asPath);
	return (
		<StyledGrid>
			{newsStories.length === 0 && <NoSearchResultsMessage />}
			{newsStories.map((item) => {
				const firstImage = item.images?.[0]?.fields;
				const imageSrc = firstImage?.file.url || NewsCardNoImage;

				return (
					<StyledGridItem
						columns={[4, { tablet: 6, mobileXL: 12 }]}
						key={item.slug}
					>
						<NewsCard
							title={item.title}
							summary={item.summary}
							imageSource={imageSrc}
							linkHref={`${asPath}/item/${item.slug}`}
							publicationDate={item.publicationDate}
							cardOrientation="vertical"
							titleFontSize={24}
							variant="vertical"
							category={item.category}
						/>
					</StyledGridItem>
				);
			})}
		</StyledGrid>
	);
};

const StyledGrid = styled(Grid.withComponent('ul'))`
	padding-left: 0;
	list-style: none;
`;

const StyledGridItem = styled(GridItem.withComponent('li'))`
	display: flex;
	padding-left: 0;
`;
